import React from 'react'

import moment from 'moment'
import {inWords} from '../../../utils/misc'
import {getUserSettings} from '../../../storage'
import HistoryChoser from '../historyChoser'

const TableCustomPadding = () =>(
  <style>
{".preview-a4 .table>tbody>tr>td { padding: 8px;}"}
  </style>
)

export default class PreviewTrader2 extends React.Component {

  render() {

    let company = this.props.company
    let invoice = this.props.invoice
    let settings = this.props.settings || getUserSettings()
    let historyRecords = this.props.history
    let brandRow = <small><i>Generated with https://www.goodsbill.com</i></small>
    let invoice_date = moment(invoice.date).format('D-MM-YYYY')
    let billto_1, billto_2, billFrom
    let place_of_supply
    let shipping_address
    let optionalRow = false
    let table_cols = 6
    let invoice_label = "INVOICE"
    let roundOffValue
    let transportlabel = invoice.transportlabel



    let serial = invoice.series_name + invoice.series_counter
    let bankDetails, declartion, tnc
    let settingOptions = settings.options || {}
    let historySelection
    if(settingOptions && settingOptions.show_invoice_history) {
      historySelection = <HistoryChoser handleHistorySelect={this.props.handleHistorySelect} records ={historyRecords} />
    }
    if(settings.invoice_label) {
      invoice_label = <div className="">
         <span>{settings.invoice_label}</span>
      </div>

      if(settings.show_invoice_tnc) {

      tnc = <div><u>Terms and Conditions</u>
            <div><p>{settings.invoice_tnc}</p></div>
            </div>
      }

      if(settings.show_invoice_declaration) {

      declartion = <div><u>Declaration</u>
            <div><p>{settings.invoice_declaration}</p></div>
            </div>
      }

      if(settings.show_invoice_bankdetails) {

        bankDetails = <div><div className="row">
              <div className="col-xs-12 space-small-bottom"><strong >Bank Details</strong></div>
            <div className="col-xs-6">Bank Name</div>
            <div className="col-xs-6">{company.bank_name}</div>
            </div>
            <div className="row">
              <div className="col-xs-6">Account No</div>
              <div className="col-xs-6">{company.account_no}</div>
            </div>
            <div className="row">
              <div className="col-xs-6">IFSC</div>
              <div className="col-xs-6">{company.ifsc_code}</div>
            </div>
            <div className="row">
              <div className="col-xs-6">Branch </div>
              <div className="col-xs-6">{company.branch_name}</div>
            </div>

            </div>
      }
    }

    let label_row=<div className="row">
                  <div className="col-xs-4 col-xs-offset-4">
                    <div className="text-center">{invoice_label}</div>
                  </div>

                  <div className="col-xs-4"><div className="text-right">
                    {this.props.print_type}
                  </div></div>
    </div>




    let company_gstin, company_phone, company_name, company_address, company_additional_params

    if(typeof company.gstin !== "undefined" && company.gstin.length > 0) {
      company_gstin = <span>{"GSTIN: " +company.gstin}</span>
    }
    if(company.additional_params && company.additional_params.length) {
      let additional_params_list = company.additional_params.map(function(param, i) {
        return <li key={i}><span className="gray">{param.key} {param.value}</span></li>
      })
      company_additional_params= <ul className="list-inline" style={{marginBottom:0}}>{additional_params_list}</ul>
    }

    if(typeof company.phone !== "undefined" && company.phone.length > 0) {
      company_phone = <span >{"Ph: " +company.phone}</span>
    }
    if(typeof company.company_name !== "undefined" && company.company_name.length > 0) {
      company_name = <div className="company-name text-uppercase" style={{fontSize:'125%', fontWeight:400}}>

                      {company.company_name}
                    </div>
    }
    company_address = <div className=""> {company.address} {company.city} {company.state} {company.pin}</div>

    let invoice_box = <div className="text-center">
    <div className="space-small">
    <div><strong>Invoice No.</strong></div>
    <div><strong>{serial}</strong></div>
    </div>

    </div>
    let invoice_date_box = <div className="text-center">
      <div className="space-small">
        <div><strong>Date</strong></div>
        <div><strong>{invoice_date}</strong></div>
      </div>
    </div>



     if(typeof invoice.client !== "undefined" && invoice.client !== null) {
       place_of_supply = invoice.client.city
       let client_gstin
       let client_phone
       let shipping_address
       if(typeof invoice.client.gstin !== "undefined" && invoice.client.gstin !== null && invoice.client.gstin.length > 0) {
         client_gstin = "GSTIN-"+invoice.client.gstin
       }
       if(typeof invoice.client.phone !== "undefined" && invoice.client.phone !== null && invoice.client.phone.length > 0) {
         client_phone = "Ph: " + invoice.client.phone
       }

       if(!invoice.client.same_as_biiling) {
         shipping_address = <div>
           {invoice.client.shipping_address}
             <div>{invoice.client.shipping_city} {" "+invoice.client.shipping_state} {" "+invoice.client.shipping_pin}
             </div>
             <div>
               {invoice.client.shipping_state_code.length > 0 ? " State Code: "+invoice.client.shipping_state_code: ""}
             </div>
         </div>
       }
       else {
         shipping_address = <div>
           {invoice.client.address}
             <div>{invoice.client.city} {" "+invoice.client.state} {" "+invoice.client.pin}
             </div>
             <div>
               {invoice.client.state_code.length > 0 ? " State Code: "+invoice.client.state_code: ""}
             </div>
         </div>
       }

       billto_1 =  <div className="row"><div className="col-xs-12">
         <div className="">
         <table>
         <tbody>
          <tr><td>Name:</td><td style={{fontSize:'120%', fontWeight:400}}>{invoice.client.name}</td></tr>
          <tr><td>Phone:</td><td>{invoice.client.phone}</td></tr>
          <tr><td>Address:</td><td>{invoice.client.address}
            <div>{invoice.client.city} {" "+invoice.client.state} {" "+invoice.client.pin}</div></td></tr>
          <tr><td>Delivery At:</td><td>{shipping_address}</td></tr>
         </tbody>
         </table>
         </div>
       </div></div>

     }

     let vehicle_no_box
     if(typeof transportlabel !== "undefined" && transportlabel !== null) {
       vehicle_no_box = <div className="text-center space-small">
          <div><strong style={{whiteSpace:'nowrap'}}>Vehicle Number</strong></div>
          <div><strong>{transportlabel.vehicle_no}</strong></div>
       </div>
     }
     let purchase_order_box
     if(settingOptions && settingOptions.enable_invoice_purchase_order) {
       purchase_order_box = <div className="text-center space-small">
         <div><strong style={{whiteSpace:'nowrap'}}>Purchase Order No.</strong></div>
         <div><strong>{invoice.purchase_order_no}</strong></div>
       </div>
     }

     let company_row = <tr><td colSpan={table_cols-4}>
     {company_name}
     {company_address}
     {company_gstin} {company_phone}
   </td><td colSpan={2} rowSpan={2}>
      <div style={{display:'flex', flexDirection:'column', justifyContent:'space-between'}}>
        <div>{invoice_box}</div>
        <div>{purchase_order_box}</div>
        <div>{vehicle_no_box}</div>
      </div>
      </td>
      <td colSpan={2}>
         {invoice_date_box}
      </td>
    </tr>



     let client_row = <tr><td colSpan={table_cols-4} style={{paddingBottom:5}}>
     {billto_1}
     </td>
      <td colSpan={2}></td>
   </tr>

     let header_row = <tr className="active">
        <td className="text-center" style={{maxWidth:18}}>S.No</td>
        <td>Description</td>
        <td className="text-center">HSN</td>
        <td className="text-center" style={{maxWidth:18}}>Qty</td>
        <td className="text-right">Rate</td>

        <td className="text-right">Total</td>
     </tr>



     let items, summaryRow
     if(invoice.saleitem_set.length > 0) {
       invoice.saleitem_set.sort((a,b)=>{
         return a.tableIndex - b.tableIndex
       })
         items = invoice.saleitem_set.map((saleitem, index)=>{

           let imei_1, imei_2, battery, charger
           if(saleitem.extra){
              let extra = saleitem.extra
             if(extra.imei_1) {
               imei_1 = <div>IMEI 1: {extra.imei_1}</div>
             }
             if(extra.imei_2) {
               imei_2 = <div>IMEI 2: {extra.imei_2}</div>
             }
             if(extra.battery) {
               battery = <div>Battery: {extra.battery}</div>
             }
             if(extra.charger) {
               charger = <div>Charger: {extra.charger}</div>
             }

           }
           let description = <div>
                <div>{saleitem.name}</div>
                {imei_1}
                {imei_2}
                {battery}
                {charger}
           </div>

           let discountCol, taxCol, sgstcol, igstcol

           let unit_price = Number(saleitem.selling_basic_rate),
           taxable_price = parseFloat(saleitem.price).toFixed(2),
           item_total = parseFloat(saleitem.total).toFixed(2)


           if(saleitem.cgst_amount > 0) {
             taxCol=  <td  className="text-right">
             {parseFloat(saleitem.igst_amount).toFixed(2)} ({Number(saleitem.gst.igst)}%)
                </td>
           }
           else {
             taxCol= <td className="text-right"></td>
           }

           return <tr key={index}>
             <td className="text-center">{saleitem.tableIndex}</td>
             <td><div>{description}</div> </td>
             <td className="text-center"><div>{saleitem.hsn}</div> </td>
             <td className="text-center">
               <div>{Number(saleitem.quantity)}</div>
             </td>

             <td className="text-right">{unit_price}</td>

             <td className="text-right">{taxable_price}</td>
         </tr>

         })
     }




          let summaryQuantity=0, summaryDiscount=0, summaryTaxable=0, summaryIGST=0, summaryCGST=0, summarySGST=0, summaryTotal=0, summaryRate=0
          let percentages={cgst:{}, sgst:{}, igst:{}}
          for (var i = 0; i < invoice.saleitem_set.length; i++) {
              const si = invoice.saleitem_set[i]
              summaryRate = summaryRate + (parseFloat(si.quantity)* parseFloat(si.selling_rate))
              summaryQuantity = summaryQuantity + parseFloat(si.quantity)
              summaryDiscount = summaryDiscount + parseFloat(si.discount_value)
              summaryTaxable = summaryTaxable + parseFloat(si.price)
              summaryIGST = summaryIGST + parseFloat(si.igst_amount)
              summaryCGST = summaryCGST + parseFloat(si.cgst_amount)
              summarySGST = summarySGST + parseFloat(si.sgst_amount)
              summaryTotal = summaryTotal + parseFloat(si.total)
              const unique_cgst_pct = si.gst.cgst, unique_sgst_pct = si.gst.sgst, unique_igst_pct = si.gst.igst
              const igst_s_amount = parseFloat(si.igst_amount)
              const cgst_s_amount = parseFloat(si.cgst_amount)
              const sgst_s_amount = parseFloat(si.sgst_amount)
              const taxable_price = parseFloat(si.price)
              const total = parseFloat(si.total)

              let cgst_percentages = percentages['cgst']

              if(typeof cgst_percentages[unique_cgst_pct] !== "undefined") {
                let s = cgst_percentages[unique_cgst_pct]

                s.cgst_amount= s.cgst_amount + cgst_s_amount
                s.sgst_amount= s.sgst_amount + sgst_s_amount
                // s.igst_amount= s.igst_amount + igst_s_amount
                s.taxable_price = s.taxable_price + taxable_price
                s.total = s.total + total

              }
              else {
                cgst_percentages[unique_cgst_pct] = {cgst_amount:cgst_s_amount,  sgst_amount:sgst_s_amount, taxable_price: taxable_price, total: total}
                //percentages[unique_pct] = {igst_amount:igst_s_amount, cgst_amount:cgst_s_amount, sgst_amount:sgst_s_amount, taxable_price: taxable_price, total: total}
              }
              percentages['cgst'] = cgst_percentages

              let igst_percentages = percentages['igst']

              if(typeof igst_percentages[unique_igst_pct] !== "undefined") {
                let s = igst_percentages[unique_igst_pct]
                s.igst_amount= s.igst_amount + igst_s_amount
                s.taxable_price = s.taxable_price + taxable_price
                s.total = s.total + total
              }
              else {
                igst_percentages[unique_igst_pct] = {igst_amount:igst_s_amount, taxable_price: taxable_price, total: total}
                //percentages[unique_pct] = {igst_amount:igst_s_amount, cgst_amount:cgst_s_amount, sgst_amount:sgst_s_amount, taxable_price: taxable_price, total: total}
              }

              percentages['igst'] = igst_percentages
            }

            summaryRate = parseFloat(summaryRate).toFixed(2)
            summaryDiscount = parseFloat(summaryDiscount).toFixed(2)
            summaryTaxable = parseFloat(summaryTaxable).toFixed(2)
            summaryIGST = parseFloat(summaryIGST).toFixed(2)
            summaryCGST = parseFloat(summaryCGST).toFixed(2)
            summarySGST = parseFloat(summarySGST).toFixed(2)
            summaryTotal = parseFloat(summaryTotal).toFixed(2)

            roundOffValue= parseFloat(invoice.total) - parseFloat(summaryTotal)

            if(roundOffValue >= 0) {
                roundOffValue = "+" + parseFloat(roundOffValue).toFixed(2)
            }
            else {
                roundOffValue = parseFloat(roundOffValue).toFixed(2)
            }




          let cgst_percentages = percentages['cgst']
          let igst_percentages = percentages['igst']

          let summary_cgst_row, summary_sgst_row, summary_igst_row
          if(invoice.is_igst) {
            let keys =  Object.keys(igst_percentages)
            summary_igst_row = keys.map((pct_key)=>{
             let igst_percentage = igst_percentages[pct_key]
             console.log(igst_percentage);
             return <tr className="text-right" key={"cgst_summary_row"+pct_key}>
                   <td colSpan={table_cols-4} style={{borderBottomWidth:1,borderBottomStyle:'solid', borderBottomColor:'transparent'}}></td>

                   <td colSpan={2}><div>CGST</div><div>SGST</div><div>IGST</div></td>
                   <td><div>0%</div><div>0%</div><div>{Number(pct_key)}%</div></td>
                   <td><div>0.00</div><div>0.00</div><div>{parseFloat(igst_percentage.igst_amount).toFixed(2)}</div></td>

             </tr>
           })


          }
          else {
            let keys =  Object.keys(cgst_percentages)
            summary_cgst_row = keys.map((pct_key)=>{
             let cgst_percentage = cgst_percentages[pct_key]

             return <tr className="text-right" key={"sgst_summary_row"+pct_key}>
                   <td colSpan={table_cols-4} style={{borderBottomWidth:1,borderBottomStyle:'solid', borderBottomColor:'transparent'}}></td>
                   <td colSpan={2}>CGST</td>
                   <td>{pct_key}%</td>
                   <td>{parseFloat(cgst_percentage.sgst_amount).toFixed(2)}</td>
             </tr>
           })

            summary_sgst_row = keys.map((pct_key)=>{
             let cgst_percentage = cgst_percentages[pct_key]

             return <tr className="text-right" key={"sgst_summary_row"+pct_key}>
                   <td colSpan={table_cols-4} style={{borderBottomWidth:1,borderBottomStyle:'solid', borderBottomColor:'transparent'}}></td>
                   <td colSpan={2}>SGST</td>
                   <td>{pct_key}%</td>
                   <td>{parseFloat(cgst_percentage.sgst_amount).toFixed(2)}</td>
             </tr>
           })


          }

          let emptyRow = <tr><td colSpan={table_cols}>&nbsp;</td></tr>
          let emptyRowWithNoBorder = <tr><td colSpan={table_cols} style={{borderBottomColor:'transparent'}}>&nbsp;</td></tr>

            let footer = <tr>
            <td colSpan={table_cols}>
             <div className="row">
                  <div className="col-xs-6">
                    <div className="space-small">{tnc}</div>
                      <div className="space-small">{declartion}</div>

                    <div className="space-small" style={{paddingTop:40}}>
                        Customer's Signature
                    </div>

                  </div>
                  <div className="col-xs-6 text-right" style={{position:'relative', transform:'translateY(76%)'}}>
                      <div className="space-large-bottom"><strong>For <span>{company.company_name}</span></strong></div>
                      <div>Authorized Signature</div>
                  </div>
            </div>
            </td>
            </tr>


    return  <div style={{position:'relative'}}>
      <div className="hidden-print" style={{position:'absolute', left:0}}>
        {historySelection}
      </div>
    <div className="preview-a4 mobile">
      {label_row}
    <table className="table table-bordered">
    <tbody>

      {company_row}
      {client_row}
      {header_row}
      {items}

      {emptyRowWithNoBorder}{emptyRow}
      <tr>
      <td colSpan={table_cols-4}></td><td colSpan={3} className="text-center"><strong>SUB TOTAL</strong></td><td className="text-right"><strong>{summaryTaxable}</strong></td>
      </tr>
      {summary_cgst_row}
      {summary_sgst_row}
      {summary_igst_row}
      <tr>
      <td colSpan={table_cols-4}></td><td colSpan={3} className="text-center">Roundoff</td><td className="text-right">{roundOffValue}</td>

      </tr>
      <tr>
      <td colSpan={table_cols-4}></td><td colSpan={3} className="text-center"><strong>GRAND TOTAL</strong></td><td className="text-right"><strong>{invoice.total}</strong></td>
      </tr>
      <tr>
        <td colSpan={table_cols}>
          <ul className="list-inline">
            <li><strong>{inWords(invoice.total)}</strong></li>
          </ul>

        </td>
      </tr>
      {footer}
    </tbody>
    </table>
    <div className="text-center" style={{fontSize:'90%'}}>
        {settingOptions.jurisdiction_notes}
    </div>
  </div></div>
  }
}



// WEBPACK FOOTER //
// ./src/components/invoice/previews/previewtrader2.js